import React, { useState } from 'react';

interface HeroProps {
  navigateToCallMe: () => void;
}

export function Hero({ navigateToCallMe }: HeroProps) {
  const scrollToInsuranceSection = () => {
    const section = document.getElementById('insurance-section');
    if (section) {
      const offset = section.offsetTop - 32;
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="bg-green-50 py-16 px-4">
      <div className="max-w-4xl mx-auto text-center fade-in">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 slide-up">
          Få personlig rådgivning fra selvstændige forsikringseksperter
        </h1>
        <p className="text-xl text-gray-600 mb-8 slide-up" style={{ animationDelay: '0.2s' }}>
          Vælg dine foretrukne selskaber og bliv kontaktet af en ekspert inden for 24 timer – helt uforpligtende og gratis
        </p>
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row justify-center gap-4 slide-up" style={{ animationDelay: '0.3s' }}>
            <button
              onClick={scrollToInsuranceSection}
              className="bg-green-600 text-white px-8 py-3 rounded-lg font-medium text-lg hover:bg-green-700 transition-all duration-300 transform hover:-translate-y-1 active:translate-y-0 hover:shadow-lg"
              aria-label="Start gratis forsikringstjek"
            >
              FÅ GRATIS FORSIKRINGSTJEK
            </button>
            <button
              onClick={navigateToCallMe}
              className="bg-white text-green-600 border-2 border-green-600 px-8 py-3 rounded-lg font-medium text-lg hover:bg-green-50 transition-all duration-300 transform hover:-translate-y-1 active:translate-y-0 hover:shadow-lg flex items-center justify-center"
            >
              <span className="mr-2">🎯</span>
              RING MIG OP
            </button>
          </div>
          <p className="text-sm text-gray-500 slide-up" style={{ animationDelay: '0.4s' }}>
            Mere end 10.000 danskere har allerede sparet penge på deres forsikringer gennem os
          </p>
        </div>
      </div>
    </section>
  );
}